export { default as Armchair } from "./IconArmchair.vue";
export { default as ArrowDown } from "./IconArrowDown.vue";
export { default as ArrowLeft } from "./IconArrowLeft.vue";
export { default as ArrowRight } from "./IconArrowRight.vue";
export { default as Baby } from "./IconBaby.vue";
export { default as Backspace } from "./IconBackspace.vue";
export { default as BedRoom } from "./IconBedRoom.vue";
export { default as BedsideTable } from "./IconBedsideTable.vue";
export { default as Cart } from "./IconCart.vue";
export { default as CartAdd } from "./IconCartAdd.vue";
export { default as Chair } from "./IconChair.vue";
export { default as Close } from "./IconClose.vue";
export { default as Comment } from "./IconComment.vue";
export { default as Discount } from "./IconDiscount.vue";
export { default as ExpandLess } from "./IconExpandLess.vue";
export { default as ExpandMore } from "./IconExpandMore.vue";
export { default as Folder } from "./IconFolder.vue";
export { default as FolderOpen } from "./IconFolderOpen.vue";
export { default as GroupAdd } from "./IconGroupAdd.vue";
export { default as Hanger } from "./IconHanger.vue";
export { default as Kitchen } from "./IconKitchen.vue";
export { default as Living } from "./IconLiving.vue";
export { default as LogOut } from "./IconLogOut.vue";
export { default as Mail } from "./IconMail.vue";
export { default as OneClick } from "./IconOneClick.vue";
export { default as PaginationAnimation } from "./IconPaginationAnimation.vue";
export { default as Payment } from "./IconPayment.vue";
export { default as Person } from "./IconPerson.vue";
export { default as Phone } from "./IconPhone.vue";
export { default as PhoneCalling } from "./IconPhoneCalling.vue";
export { default as Product } from "./IconProduct.vue";
export { default as Right } from "./IconRight.vue";
export { default as Schedule } from "./IconSchedule.vue";
export { default as Search } from "./IconSearch.vue";
export { default as Shipping } from "./IconShipping.vue";
export { default as Sofa } from "./IconSofa.vue";
export { default as Storage } from "./IconStorage.vue";
export { default as Table } from "./IconTable.vue";
export { default as Wardrobe } from "./IconWardrobe.vue";
export { default as Searched } from "./IconSearched.vue";
